import axios from "axios";

import { getTenantHeaders } from "fe-shared/src/helpers/tenantUtils";

import { getIdentityHostUrl } from "config";
import { CLIENT_ID } from "consts";

export const userLogout = (): Promise<boolean> => {
  const identityBaseUrl = getIdentityHostUrl();
  const apiClient = axios.create({
    baseURL: identityBaseUrl,
    timeout: 10000, // Add explicit timeout
    headers: { ...getTenantHeaders(), ...axios.defaults.headers }
  });
  
  return apiClient
    .post("api/account/revokeToken",
      {
        clientId: CLIENT_ID
      })
    .then(() => true)
    .catch(() => false);
};

export default userLogout;
